import React from 'react';
import { NavLink } from 'react-router-dom';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import SelectInput from '../../../controls/selectInput.jsx';
import TextInput from '../../../controls/textInput.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';

export default class AdminRatesForm extends React.Component {
    constructor(args) {
        super(args);        
        let rateId = this.props.match.params.id;
        this.state = {
            id: rateId ? rateId : 0,
            busyCount: 0,
            lastResponseError: null,
            companies: [],
            carriers: [],
            parcelTypes: [],
            weightMin: {},
            weightMax: {},
            clientRate: {},
            tariffRateAgent: {},
            errors: {},
            rate: {}
        };
        
        this.initRateData();
    }

    initRateData() {
        this.state.rate = {            
            companyId: null,
            carrierId: null,
            parcelType: null,
            clientRate: null,
            tariffRateAgent: 1,
            weightMin: null,
            weightMax: null                       
        };
    }

    componentDidMount() {
        this.reload();
    }

    componentWillReceiveProps(newProps) {
        let rateId = newProps.match.params.id;
        this.state.id = rateId ? rateId : 0;
        this.setState(this.state, () => {
            if (this.state.id > 0) {
                this.reloadRateData();
            } else {
                this.initRateData();
                this.setState(this.state);
            }
        });
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        this.updateBusyCount(1);
        apiGet('admin/rates/ref/allcompanies')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.companies = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('admin/rates/ref/allcarriers')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.carriers = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('admin/rates/ref/allparceltypes')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.parcelTypes = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.reloadRateData();
    }

    reloadRateData() {
        if (this.state.id > 0) { //edit
            this.updateBusyCount(1);
            apiGet('admin/rates/' + this.state.id)
                .then(data => {
                    this.updateBusyCount(-1);
                    data.companyId = data.companyId ? data.companyId : "";
                    data.carrierId = data.carrierId ? data.carrierId : "";
                    data.parcelType = data.parcelType ? data.parcelType : "";
                    this.setState((prevState, props) => {
                        prevState.rate = data;
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    if (err.status > 401) {
                        this.setState({ lastResponseError: err.status });
                    }
                });
        }
    }

    save() {
        let errors = this.validateForm();
        if (errors) {
            this.setErrors(errors);
        } else {
            var rateData = {
                id: this.state.id,
                companyId: this.state.rate.companyId,
                carrierId: this.state.rate.carrierId,
                parcelType: this.state.rate.parcelType,
                weightMin: this.state.rate.weightMin,
                weightMax: this.state.rate.weightMax,
                clientRate: this.state.rate.clientRate,
                tariffRateAgent: this.state.rate.tariffRateAgent
            };
            var applyMethod = null;
            if (this.state.id > 0) {
                applyMethod = apiPut('admin/rates/' + this.state.id, rateData);
            } else {
                applyMethod = apiPost('admin/rates/new', rateData);
            }

            applyMethod
                .then(() => {
                    this.backToList();
                })
                .catch(errors => {
                    this.setErrors(errors.messages);
                });
        }
    }

    setErrors(errors) {
        this.setState({ errors: errors });
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    validateForm() {
        var result = null;
        var regexOnlyNumber = /^\d*\.?\d*$/;

        if (!this.state.rate.companyId) {
            result = result ? result : {};
            result.companyId = "Юр.лицо клиента является обязательным полем";
        }

        if (!this.state.rate.carrierId) {
            result = result ? result : {};
            result.carrierId = "Транспортная компания является обязательным полем";
        }

        if (!this.state.rate.parcelType) {
            result = result ? result : {};
            result.parcelType = "Тип груза является обязательным полем";
        }

        if (this.isEmptyString(this.state.rate.clientRate)) {
            result = result ? result : {};
            result.clientRate = "Коэффициент Pooling является обязательным полем";
        }

        if (this.isEmptyString(this.state.rate.tariffRateAgent)) {
            result = result ? result : {};
            result.tariffRateAgent = "Коэффициент агента является обязательным полем";
        }

        if (this.state.rate.tariffRateAgent === "0") {
            result = result ? result : {};
            result.tariffRateAgent = "Коэффициент агента не может быть равен 0";
        }
        
        if (!this.isEmptyString(this.state.rate.tariffRateAgent) && !regexOnlyNumber.test(this.state.rate.tariffRateAgent)) {
            result = result ? result : {};
            result.tariffRateAgent = "Не верно заполнено поле - Коэффициент агента";
        }

        if (!this.isEmptyString(this.state.rate.clientRate) && !regexOnlyNumber.test(this.state.rate.clientRate)) {
            result = result ? result : {};
            result.clientRate = "Не верно заполнено поле - Коэффициент Pooling";
        }

        if ((this.state.rate.weightMin) && !regexOnlyNumber.test(this.state.rate.weightMin)) {
            result = result ? result : {};
            result.weightMin = "Не верно заполнено поле - Вес мин.";
        }

        if ((this.state.rate.weightMax) && !regexOnlyNumber.test(this.state.rate.weightMax)) {
            result = result ? result : {};
            result.weightMax = "Не верно заполнено поле - Вес макс.";
        }

        
                
        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    backToList() {
        this.props.history.push('/admin/rates/list');
    }

    handleInputChange(name, value) {
        let rate = this.state.rate;
        rate[name] = value;
        this.setState({
            rate: rate
        });
    }
        
    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }

        let isNew = this.state.id < 1;
        let isBusy = this.state.busyCount > 0;
        let header = isNew
            ? (
                <section className="content-header">
                    <h1>Новый коэффициент</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/rates/list">Коэффициенты</NavLink></li>
                        <li className="active">Новый коэффициент</li>
                    </ol>
                </section>
            )
            : (
                <section className="content-header">
                    <h1>Коэффициент</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/rates/list">Коэффициенты</NavLink></li>
                        <li className="active">{this.state.rate.companyId}</li>
                    </ol>
                </section>
            );
        return (
            <div>
                {header}
                <section className="content">
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="box box-primary">
                                <div className="box-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.companyId ? " has-error" : "")}>
                                                <label htmlFor="selectCompanyId">Юр.лицо клиента<span className="text-red">*</span></label>
                                                <SelectInput id="selectCompanyId"
                                                    options={this.state.companies}
                                                    title={this.state.errors.companyId}
                                                    value={this.state.rate.companyId}
                                                    onChange={value => this.handleInputChange("companyId", value.value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.carrierId ? " has-error" : "")}>
                                                <label htmlFor="selectCarrierId">Транспортная компания<span className="text-red">*</span></label>
                                                <SelectInput id="selectCarrierId"
                                                    options={this.state.carriers}
                                                    title={this.state.errors.carrierId}
                                                    value={this.state.rate.carrierId}
                                                    onChange={value => this.handleInputChange("carrierId", value.value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.parcelType ? " has-error" : "")}>
                                                <label htmlFor="selectParcelType">Тип груза<span className="text-red">*</span></label>
                                                <SelectInput id="selectParcelType"
                                                    options={this.state.parcelTypes}
                                                    title={this.state.errors.parcelType}
                                                    value={this.state.rate.parcelType}
                                                    onChange={value => this.handleInputChange("parcelType", value.value)}
                                                    disabled={isBusy}
                                                />
                                            </div>                                            
                                        </div>
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.weightMin ? " has-error" : "")}>
                                                <label htmlFor="inputWeightMin">Вес мин. (включительно)</label>
                                                <TextInput id="inputWeightMin"
                                                    title={this.state.errors.weightMin}
                                                    value={this.state.rate.weightMin}
                                                    onChange={value => this.handleInputChange("weightMin", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.weightMax ? " has-error" : "")}>
                                                <label htmlFor="inputWeightMax">Вес макс. (не включительно)</label>
                                                <TextInput id="inputWeightMax"
                                                    title={this.state.errors.weightMax}
                                                    value={this.state.rate.weightMax}
                                                    onChange={value => this.handleInputChange("weightMax", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.clientRate ? " has-error" : "")}>
                                                <label htmlFor="inputClientRate">Коэффициент Pooling<span className="text-red">*</span></label>
                                                <TextInput id="inputClientRate"
                                                    title={this.state.errors.clientRate}
                                                    value={this.state.rate.clientRate}
                                                    onChange={value => this.handleInputChange("clientRate", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.tariffRateAgent ? " has-error" : "")}>
                                                <label htmlFor="inputAgentRate">Коэффициент агента<span className="text-red">*</span></label>
                                                <TextInput id="inputAgentRate"
                                                    title={this.state.errors.tariffRateAgent}
                                                    value={this.state.rate.tariffRateAgent}
                                                    onChange={value => this.handleInputChange("tariffRateAgent", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-flat btn-default" onClick={() => this.backToList()} disabled={isBusy}>
                                        Отмена
                                    </button>
                                    <button className="btn btn-flat btn-primary pull-right" onClick={() => this.save()} disabled={isBusy}>
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/rates/ratesForm.jsx